import React from "react";
import { Link } from "react-router-dom";

// images \\
import calendar from "../../assets/images/calendar.svg";
import users from "../../assets/images/users.svg";
import cash from "../../assets/images/cash.svg";

// styles \\
import "../../assets/styles/sections/hero.scss";

const Hero = () => {
  return (
    <section className="hero">
      <div className="container">
        <div className="hero_items">
          <div className="hero_items_content">
            <p>Caring for Life</p>
            <h2>
              Leading the Way <br /> in Medical Excellence
            </h2>
            <Link className="service_btn">Our Services</Link>
          </div>

          <div className="hero_items_appointmentItems">
            <Link to={"/appointment"} className="items_Link">
              Book an Appointment
              <img src={calendar} alt="calendar" className="calendar" />
            </Link>
            <Link to={"/doctors"} className="items_Link odd ">
              About Out Team
              <img src={users} alt="users" />
            </Link>
            <Link to={"/news"} className="items_Link odd_1 calendar">
              stay up to news
              <img src={cash} alt="cash" />
            </Link>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Hero;
